import React from "react"
import { Link } from "gatsby"

import Layout from "../components/layout"
import Image from "../components/image_old"
import SEO from "../components/seo"

import Showcase from "../components/Showcase"
import Column from "../components/Column"
import Gallery from "../components/Gallery"

const IndexPage = () => {
  return (
    <Layout>
      <Showcase
        title="Charlie's Bakery"
        desc="A very fancy bakery."
        img="https://images.pexels.com/photos/205961/pexels-photo-205961.jpeg?auto=compress&cs=tinysrgb&dpr=3&h=750&w=1260"
      />
      {/* <Column
        title="Map"
        desc="You can find us on Google Maps. Feel free to visit anytime!"
        bg="#335"
      /> */}
      <Column
        title="Follow Us"
        desc="Follow us on Instagram to see our latest dishes!"
        bg="#925"
      />
      <Gallery />
    </Layout>
  )
}

export default IndexPage
